module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/zh-hant_shikoku-b6a4a54f74e2490658f13a8e0485888a.jpg";